<template lang="pug">
template(v-if="footer && footer.items" )
	.page-footer__cell(v-for="(item, index) in footer.items" :key="index")
		.page-footer__block
			template(v-if="item.title" )
				h5.page-footer__block-title.flc {{item.title}}
			.page-footer__block-body.flc
				ul.page-footer-menu(v-if="item.items" )
					template(v-for="(itemLvl2, indexLvl2) in item.items" :key="indexLvl2")
						li.page-footer-menu__item(v-if="!itemLvl2.active" )
							a.page-footer-menu__link(:href="itemLvl2?.link") {{itemLvl2?.text}}
						li.page-footer-menu__item(v-else)
							span.page-footer-menu__link.active {{itemLvl2?.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			footer: {}
		};
	},

	methods: {
		dataSet(data) {
			this.footer = data;
		}
	}
};
</script>
